import Vue from "vue";
import DarkMessage from "./DarkMessage.vue";

const MessageConstructor = Vue.extend(DarkMessage);

let instance; // 单例模式
let instances = []; // 维护所有消息实例的数组
let seed = 1; // 用于生成唯一id

const DarkMessageManager = function (options) {
  if (Vue.prototype.$isServer) return; // 服务器端渲染不执行

  options = options || {};
  if (typeof options === "string") {
    options = {
      message: options,
    };
  }

  let id = "message_" + seed++;

  instance = new MessageConstructor({
    propsData: options,
  });
  instance.id = id;
  instance.$mount(); // 不挂载到DOM，只生成VNode
  document.body.appendChild(instance.$el);

  let verticalOffset = 50; // 初始垂直偏移量
  instances.forEach((item) => {
    verticalOffset += item.$el.offsetHeight + 16; // 计算每个消息的高度加上间距
  });

  instance.verticalOffset = verticalOffset;
  instance.$el.style.top = verticalOffset + "px";
  instance.visible = true;

  instance.$on("hook:beforeDestroy", () => {
    // 实例销毁前从数组中移除
    const index = instances.findIndex((item) => item.id === instance.id);
    if (index > -1) {
      instances.splice(index, 1);
    }
    // 重新调整下方消息的位置
    let removedHeight = instance.$el.offsetHeight + 16; // 被移除消息的高度和间距
    for (let i = index; i < instances.length; i++) {
      instances[i].$el.style.top =
        parseInt(instances[i].$el.style.top) - removedHeight + "px";
    }
  });

  instances.push(instance);

  return instance;
};

// 定义各种类型的方法
["success", "warning", "info", "error"].forEach((type) => {
  DarkMessageManager[type] = (options) => {
    if (typeof options === "string") {
      options = {
        message: options,
      };
    }
    options.type = type;
    return DarkMessageManager(options);
  };
});

// Vue 插件的 install 方法
DarkMessageManager.install = function (Vue) {
  Vue.prototype.$darkMessage = DarkMessageManager;
};

export default DarkMessageManager;
